import {useEffect} from "react";
import {useFormContext} from "react-hook-form";

import Button from "@/components/button/Button.tsx";
import {InputField} from "@/components/form/fields/InputField/InputField.tsx";
import {FormSubtext} from "@/components/formSubtext/FormSubtext.tsx";
import {URL_ORIGINAL_WEBSITE} from "@/lib/links.ts";
import {ServerErrors} from "@/lib/types/common.ts";
import {IntegrationFormData} from "@/lib/types/integrations.ts";
import {SetupInfo} from "@/pages/integrations/edit/subForms/components/SetupInfo.tsx";

export type FormValuesKey = keyof IntegrationFormData;

interface DiscordFormProps {
  serverErrors?: ServerErrors;
}

export const DiscordForm = ({serverErrors}: DiscordFormProps) => {
  const {setError, setValue} = useFormContext();

  useEffect(() => {
    if (serverErrors) {
      Object.keys(serverErrors)
        .filter((k) => k !== "__all__")
        .forEach((key) => setError(`settings.${key}` as FormValuesKey, {message: serverErrors[key][0]}));
    }
  }, [setError, serverErrors]);

  const oauthStart = () => {
    const bc = new BroadcastChannel("oauth_channel");

    bc.addEventListener("message", (event) => {
      setValue("settings.webhook_url", event.data.webhookUrl);
      setValue("settings.channel", event.data.channel);
    });

    window.open(
      `${URL_ORIGINAL_WEBSITE}/integrations/oauth-authorize?target=integration_discord_oauth_redirect`,
      "integration_oauth",
      "width=760,height=800,location=no,menubar=no,resizable=no,scrollbars=no,status=no,titlebar=no,toolbar=no,noreferrer"
    );
  };

  return (
    <>
      <div className="row row-cols-2 mb-3">
        <div className="col-12 mb-3">
          <Button name="authorize" onClick={oauthStart}>
            Authorize Now
          </Button>
          <FormSubtext subText="Click 'Authorize Now' to populate the required fields below." />
        </div>
      </div>
      <div className="row row-cols-2 mb-3">
        <div className="col-6 mb-3">
          <InputField name="settings.webhook_url" label="Webhook URL" required={true} disabled={true} />
        </div>
        <div className="col-6 mb-3">
          <InputField name="settings.channel" label="Channel" required={true} disabled={true} />
        </div>
      </div>
      <SetupInfo>
        <div className="p-2">
          Click the "Authorize Now" button and login to Discord in the popup window. Then, authorize the Uptime.com app
          and select which channel to send notifications to when your checks fail or recover.
        </div>
      </SetupInfo>
    </>
  );
};
